import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToHash() {
    const { hash } = useLocation();

    useEffect(() => {
        if (hash) {
            const id = hash.replace("#", "");
            const el = document.getElementById(id);

            if (el) {
                const navbarHeight = 80;

                const y =
                    el.getBoundingClientRect().top +
                    window.pageYOffset -
                    navbarHeight;

                window.scrollTo({
                    top: y,
                    behavior: "smooth",
                });
            }
        }
    }, [hash]);

    return null;
}
